import { render } from "./BulletinUpload.vue?vue&type=template&id=a88e9376"
import script from "./BulletinUpload.vue?vue&type=script&lang=js"
export * from "./BulletinUpload.vue?vue&type=script&lang=js"

import "./BulletinUpload.vue?vue&type=style&index=0&id=a88e9376&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__